import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisorgisComponent } from './visorgis.component';
import { VisorgisRoutingModule } from './visorgis-routing.module';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { CardRightComponent } from './components/card-right/card-right.component';
import { VisorgisService } from './services/visorgis.service';
import { CreateModalComponent } from './components/create-modal/create-modal.component';
import { DrawHidranteComponent } from './components/create-modal/draw-hidrante/draw-hidrante.component';
import { DrawTomaComponent } from './components/create-modal/draw-toma/draw-toma.component';
import { DrawPozoComponent } from './components/create-modal/draw-pozo/draw-pozo.component';
import { FiltroSearchPipe } from './filtro-search.pipe';
import { GisComponent } from './components/gis/gis.component';
import { MarkerPopupComponent } from './components/markerPopup/markerPopup.component';
import { LoadSpinnerComponent } from '../../shared/components/load-spinner/load-spinner.component';

@NgModule({
  imports: [
    CommonModule,
    VisorgisRoutingModule,
    LeafletModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    VisorgisComponent,
    CardRightComponent,
    CreateModalComponent,
    DrawHidranteComponent,
    DrawTomaComponent,
    DrawPozoComponent,
    FiltroSearchPipe,
    GisComponent,
    MarkerPopupComponent,
    LoadSpinnerComponent,
  ],
  providers: [VisorgisService, provideHttpClient(withInterceptorsFromDi())],
})
export class VisorgisModule {}
